module.exports = "/images/oculus-14.jpg";